import React, { useEffect } from "react";
import { Route, Routes, Navigate } from "react-router-dom";
import { ThemeProvider } from "@mui/material/styles";
import { baseTheme } from './assets/global/Theme-variable';
import ThemeRoutes from "./routes/Router";
import createCache from '@emotion/cache';
import { CacheProvider } from "@emotion/react";
import rtlPlugin from 'stylis-plugin-rtl';
import { Toaster } from "react-hot-toast";
import setupInterceptors from './axios/setup';

const App = () => {
  useEffect(() => {
    setupInterceptors();
  }, []);

  const theme = baseTheme;
  const cacheRtl = createCache({
    key: 'muirtl',
    stylisPlugins: [rtlPlugin],
  });

  return (
    <CacheProvider value={cacheRtl}>
      <ThemeProvider theme={theme}>
        <Routes>
          {ThemeRoutes.map((route, index) => (
            <Route
              key={index}
              path={route.path}
              element={route.element}
            >
              {route.children && route.children.map((childRoute, childIndex) => (
                <Route
                  key={childIndex}
                  path={childRoute.path}
                  element={childRoute.element}
                />
              ))}
            </Route>
          ))}
          <Route path="*" element={<Navigate to="/404" />} />
        </Routes>
      </ThemeProvider>
      <Toaster position="bottom-center" />
    </CacheProvider>
  );
};

export default App;
